module.exports = __webpack_public_path__ + "static/img/Vuejs1.93b2534.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/article/Vuejs1.jpg
// module id = kZmo
// module chunks = 0